import { api } from '@api/api2';
import {
  ImportInterruptPayload,
  ImportReadNotificationPayload,
  DownloadFile,
} from '../types';

const getActiveExports = () => api.v4('get', 'export/get-active-exports');

const exportInterrupt = (payload: ImportInterruptPayload) =>
  api.v4('get', 'export/interrupt-export', payload);

const importReadNotification = (payload: ImportReadNotificationPayload) =>
  api.v4('post', 'import/read-import-notification', payload);

const downloadFile = (payload: DownloadFile) =>
  api.v4('get', 'export/get-file', {
    ...payload,
    ...{ responseType: 'arraybuffer' },
  });

export const apiExportMethods = {
  getActiveExports,
  exportInterrupt,
  importReadNotification,
  downloadFile,
};
